import { axios } from '@Root/API'

export const create = (contactId, payload) => {
  return axios.post(`get/contact/${contactId}/admission`, { ...payload })
}
